import { Box, Grid } from "@mui/material";
import { useState, useEffect } from "react";

import ModalTrigger from "../Common/ModalTrigger";
import CustomLink from "../Common/CustomLink";
import ButtonsSelect from "../Common/ButtonsSelect";

import csv7 from "../../Data/MANCP/FoodProduct/MANCP-Comparison-of-organic-and-conventional-products-Grouped-bar-chart.csv";

import DodgeBarChart from "../Charts/DodgeBarChart";

const OrganicFoodProducts = (props) => {
  const [comparisonFilter, setComparisonFilter] = useState(0);

  const comparisonFilterHandler = (event) => {
    setComparisonFilter(event);
  };
  return (
    <Grid
      item
      container
      direction={{ xs: "column", sm: "column", md: "row" }}
      sx={{ marginTop: { xs: "50px", sm: "50px", md: "90px" } }}
    >
      <Grid
        item
        xs
        sx={{
          paddingLeft: { xs: "24px", sm: "24px", md: "24px" },
          paddingRight: { xs: "24px", sm: "45px", md: "24px" },
          paddingBottom: { xs: "24px", sm: "24px", md: "24px" },
          paddingTop: { xs: "0px", sm: "0px", md: "24px" },
        }}
        className="sever-one"
      >
        <Box sx={{ textAlign: { xs: "left", sm: "center", md: "left" } }}>
          <h3>Results for organic food products</h3>
          <p className="paragraph">
            No specific MRLs exist for organic products. The MRLs set
            in{" "}
            <CustomLink
              text=" Regulation (EC) No 396/2005"
              href="https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32005R0396&from=EN"
            />{" "}
            apply equally to organic and conventional food. However, Regulation (EU) No 2021/1165 authorises certain products and substances for use in organic production. In 2024{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="MRL exceedances"
            />{" "}
            were lower in organic food than in conventionally produced food across all food product categories analysed, except for animal products.
          </p>
          <p className="paragraph">
            In 2024, 5,939 samples were labelled as organic food (excluding 454 baby food samples) and analysed, corresponding to 6.9% of the total samples. This was a slight increase compared to 2023 (5.3%). Of these, 878 samples were reported under the{" "}
            <ModalTrigger
              style={{
                color: "#22294D",
                cursor: "pointer",
                borderBottom: "1px dotted",
              }}
              text="EU MACP"
            />
            .
          </p>
          <p className="paragraph">
            Overall, 4,774 samples flagged as organic did not contain quantifiable residues (80.4% vs 80% in 2023) and 1,114 samples contained quantified residues below or at the MRL level (18.8% vs 19% in 2023). Of 51 samples (0.9% vs 0.9% in 2023) reported to have residue levels above their corresponding MRLs, 0.4% (21 samples) were non-compliant.
          </p>
          <p className="paragraph">
            The pesticides most frequently detected above the LOQ but below the MRL were copper (46.3%), spinosad (5.1%), and, bromide ion (3.2%). The pesticides most frequently exceeding the MRL were chlorates (0.1%) and chlorpyrifos (0.1%).
          </p>
        </Box>
      </Grid>
      <Grid item xs={7} p={1}>
        <Box>
          <ButtonsSelect
            onButtonClick={comparisonFilterHandler}
            firstButton="≤MRL"
            secondButton=">MRL"
          />
        </Box>
        <Box sx={{ width: "100%" }}>
          <DodgeBarChart
            csv={csv7}
            title="Comparison of organic and conventional products"
            comparisonFilter={comparisonFilter}
          />
        </Box>
      </Grid>
    </Grid>
  );
};

export default OrganicFoodProducts;
